import jwtDecode from 'jwt-decode';
import * as Cookies from 'js-cookie';

const cookieKey = process.env.REACT_APP_JWT_COOKIE_KEY;

export function removeSession() {
  Cookies.remove(cookieKey);
}

export function currentSession() {
  const token = Cookies.get(cookieKey);
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    const expired = decoded.exp < Date.now() / 1000;
    if (expired) return removeSession();
    return {
      token,
      user: decoded.data.user,
    };
  } catch (error) {
    return null;
  }
}

export function saveSession(token) {
  Cookies.set(cookieKey, token, { expires: 7 });
  return token;
}
